module.exports = __webpack_public_path__ + "static/_0010_ZIKXO-da9adab71e08bcffb2fe88e6c9c858da.jpg";